import { PDFDocument } from 'pdf-lib';

export const fileToObject = (file) => ({
  name: file.name,
  size: file.size,
  lastModified: file.lastModified,
  type: file.type,
  fileObject: file,
});

export const canReadPDF = async (file) => {
  try {
    const arrayBuffer = await file.arrayBuffer();
    await PDFDocument.load(arrayBuffer);
    return true;
  } catch (err) {
    console.warn('PDF ilegible:', err);
    return false;
  }
};
